import React from 'react'

import StaticComponent, { type IProps } from 'ui/src/StaticComponent/StaticComponent'
import FMCGRegistrationForm from './FMCGRegistrationFormWrapper/FMCGRegistrationFormWrapper'

export default function StaticComponentWrapper(props: IProps) {
  return <StaticComponent {...props} FMCGRegistrationForm={FMCGRegistrationForm} />
}
